import { render } from "./resheduleApptModal.vue?vue&type=template&id=18674bc5"
import script from "./resheduleApptModal.vue?vue&type=script&lang=js"
export * from "./resheduleApptModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__